import List from "./List";
import ScaleBalanceIcon from "mdi-material-ui/ScaleBalance";

export const BalanceList = List;
export const BalanceIcon = ScaleBalanceIcon;
